import React, { useState } from 'react';
import { Avatar } from '@mui/material';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import LogoutIcon from '@mui/icons-material/Logout';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import colors from '../../../../scss/colors';
import { useWindowSize } from '../../../../utils/hooks';
import { responsiveSizeTimesheet } from '../../../../utils/constants';
import { stringToHslColor } from '../../../../utils/helpers';
import IconWithPopper from '../../../common/IconWithPopper/IconWithPopper';
import MainButton from '../../../common/buttons/MainButton';
import LanguageSwitcher from '../../../languageSwitcher/LanguageSwitcher';
import BottomLinks from '../../../common/BottomLinks/BottomLinks';
import classes from './ProfileButton.module.scss';

function ProfileAvatar({ innerSize = 36, fontSize = 18 }) {
  return (
    <div className={classes.outerContainer}>
      <div className={classes.innerContainer}>
        <Avatar
          sx={{
            width: innerSize,
            height: innerSize,
            bgcolor: stringToHslColor(
              `${localStorage.getItem('AirswiftFirstName')?.[0] || ' '} ${
                localStorage.getItem('AirswiftLastName')?.[0] || ' '
              }`,
              20,
              40
            ),
            '&.MuiAvatar-root': {
              fontSize,
              color: colors.WHITE,
              fontWeight: 600
            }
          }}
        >
          {(localStorage.getItem('AirswiftFirstName')?.[0] || ' ') +
            (localStorage.getItem('AirswiftLastName')?.[0] || ' ')}
        </Avatar>
      </div>
    </div>
  );
}

export function ProfileCard({ logoutIdentifier, boxShadowVal }) {
  const accessTo = useSelector((state) => state.accessToParts);
  const [t] = useTranslation();
  const size = useWindowSize();
  const { instance } = useMsal();
  const navigate = useNavigate();

  const goToProfile = () => {
    if (size.width < responsiveSizeTimesheet) {
      window.location.pathname = '/my-profile';
    } else {
      navigate('/my-profile');
    }
  };

  const goToTifo = () => {
    if (size.width < responsiveSizeTimesheet) {
      window.location.pathname = '/dashboard/tifo';
    } else {
      navigate('/dashboard/tifo');
    }
  };

  const logout = () => {
    logoutIdentifier();
    localStorage.clear();
    instance.logoutRedirect().catch((e) => {
      console.error(e);
    });
  };

  return (
    <Box
      sx={{
        width: 'max-content',
        padding: '12px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: '16px',
        backgroundColor: '#F6F7F9',
        boxShadow: boxShadowVal,
        borderRadius: '20px'
      }}
    >
      <div className={classes.profileContainer}>
        <div className={classes.profileWrapper}>
          <ProfileAvatar innerSize={42} fontSize={22} sx={{ p: 2 }} />
          <p className={classes.userName}>{`${localStorage.getItem('AirswiftFirstName')} ${localStorage.getItem(
            'AirswiftLastName'
          )}`}</p>
          {!accessTo.tAndEApprover && (
            <MainButton size="xsmall" forceWidth="170px" variant="disabled" rounded outlined action={goToProfile}>
              <p className={classes.btnLabel}>{t('common.general.myprofile')}</p>
            </MainButton>
          )}
          {/* <MainButton size="xsmall" forceWidth="170px" variant="disabled" rounded outlined action={goToProfile}>
            <p className={classes.btnLabel}>{t('common.general.accountsettings')}</p>
          </MainButton> */}

          {accessTo.onboarding && (
            <MainButton size="xsmall" forceWidth="170px" variant="disabled" rounded outlined action={goToTifo}>
              <p className={classes.btnLabel}>{t('common.general.onboarding')}</p>
            </MainButton>
          )}
        </div>
      </div>
      <div className={classes.languageContainer}>
        <LanguageSwitcher gap="30px" />
      </div>
      <div role="presentation" className={classes.logoutBtn} onClick={logout}>
        <LogoutIcon />
        <p>{t('common.header.menu.signout')}</p>
      </div>
      <hr className={classes.divider} />
      <div className={classes.policyContainer}>
        <BottomLinks url="https://www.airswift.com/privacy-cookie-policy/" label={t('common.footer.privacy')} />
        <div className={classes.dot} />
        <BottomLinks url="https://www.airswift.com/terms-conditions/" label={t('common.footer.term')} />
      </div>
    </Box>
  );
}

export default function ProfileButton() {
  const [loggedout, setLoggedout] = useState(false);
  const boxShadowVal = '0 4px 4px rgba(0, 0, 0, 0.25)';
  const logoutIdentifier = () => {
    setLoggedout(true);
  };

  return (
    <IconWithPopper logoutStatus={loggedout} icon={<ProfileAvatar />}>
      <ProfileCard logoutIdentifier={logoutIdentifier} logoutStatus={loggedout} boxShadowVal={boxShadowVal} />
    </IconWithPopper>
  );
}
